import OptionComponent from "./OptionComponent"

export const dataSourceDefault = [
  {
    jogadasExtras: 1,
    valor: 10,
    option: false
  },
  {
    jogadasExtras: 2,
    valor: 20,
    option: false
  },
  {
    jogadasExtras: 3,
    valor: 30,
    option: false
  }
]

export let dataSource = [...dataSourceDefault]

export const setDataSource = (stringfyDataSource) => {
  if (stringfyDataSource == null || String(stringfyDataSource).trim() === '') {
    dataSource = [...dataSourceDefault]
    return
  }
  try {
    const parsedDataSource = JSON.parse(stringfyDataSource)
    if (Array.isArray(parsedDataSource) && parsedDataSource.length > 0) {
      dataSource = parsedDataSource
    } else {
      dataSource = [...dataSourceDefault]
    }
  } catch {
    dataSource = [...dataSourceDefault]
  }
}

export const columns = [
  {
      title: "Jogadas extras",
      dataIndex: "jogadasExtras",
      key: "jogadasExtras",
      render: (jogadasExtras) => (
        <span>{jogadasExtras}</span>
      )
    },
    {
      title: "Valor",
      dataIndex: "valor",
      key: "valor",
      render: (valor) =>
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(valor),
    },
    {
        title: "Habilitado",
        dataIndex: "option",
        key: "option",
        render: (option, record) => {
          return (
            <OptionComponent option={option} record={record}/>
          )
        }
     }
]

export const handleExtraMove = (event, record) => {
  const isChecked = event.target.checked;
  // const jogadasExtras = record.jogadasExtras;
  const valor = record.valor;

  dataSource.forEach((data) => {
    if (data.valor === valor) {
      data.option = isChecked;
    }
  });
};